import React, { useEffect, useState } from 'react';
import { Alert, Form, Spinner } from 'react-bootstrap';
import './DecisionEmailPreview.css';

export const PREVIEW_LOCKED_TEXT =
    "The email preview isn't available while you view the site as another role.";
export const PREVIEW_ERROR_TEXT = "The preview couldn't be loaded.";
export const PREVIEW_EMPTY_TEXT =
    'No one on this application has an email address, so no email is sent.';

const recipientName = (email) =>
    email.recipient?.name || 'Instructor of record';

/**
 * The decision email as the server rendered it for each recipient. The
 * subject, HTML and text are shown as received; the HTML is never changed
 * here, and the sandboxed frame keeps it from running anything.
 * `status` is 'loading', 'ready', 'error' or 'locked'.
 */
export default function DecisionEmailPreview({ emails = [], status }) {
    const [selected, setSelected] = useState(0);

    // A new answer may list fewer recipients than the one before
    useEffect(() => {
        setSelected(0);
    }, [emails]);

    if (status === 'locked') {
        return (
            <p className="text-body-secondary mb-0">{PREVIEW_LOCKED_TEXT}</p>
        );
    }
    if (status === 'error') {
        return (
            <Alert variant="warning" className="mb-0">
                {PREVIEW_ERROR_TEXT}
            </Alert>
        );
    }
    if (status === 'loading') {
        return (
            <div role="status" className="text-body-secondary">
                <Spinner
                    animation="border"
                    size="sm"
                    className="me-2"
                    aria-hidden="true"
                />
                Loading the preview...
            </div>
        );
    }
    if (emails.length === 0) {
        return <p className="text-body-secondary mb-0">{PREVIEW_EMPTY_TEXT}</p>;
    }

    const email = emails[selected] || emails[0];
    const name = recipientName(email);

    return (
        <div>
            {emails.length > 1 && (
                <Form.Group
                    className="mb-2"
                    controlId="decision-email-copy-for"
                >
                    <Form.Label>Copy for</Form.Label>
                    <Form.Select
                        value={selected}
                        onChange={(e) => setSelected(Number(e.target.value))}
                    >
                        {emails.map((item, index) => (
                            <option key={index} value={index}>
                                {recipientName(item)}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            )}
            <p className="mb-2">
                <strong>Subject:</strong> {email.subject}
            </p>
            <iframe
                sandbox=""
                srcDoc={email.html}
                title={`Preview of the email to ${name}`}
                className="decision-email-preview-frame w-100 border rounded mb-2"
            />
            <details>
                <summary>Plain text</summary>
                <pre className="decision-email-preview-text border rounded p-3 mb-0">
                    {email.text}
                </pre>
            </details>
        </div>
    );
}
